module.exports = __webpack_public_path__ + "media/images/Heart_Active-a89d7bab.png";